import { BookFeature } from './book-feature';
import { environment } from '../../environments/environment';

export class Chapter extends BookFeature {

    title: string;
    sortOrder: number;
    orderName: string;
    parentChapterId: number;
    subChapters: Array<Chapter>;

    getEndpointName(): string {
        return environment.endpointUrls.chapters;
    }

}
